module.exports = __webpack_public_path__ + "img/promociones.9ca77c3e.jpeg";